module.exports = __webpack_public_path__ + "static/nilbog-44c90c0b4a3a758b8d4c22bd33946134.jpeg";